import { Flex } from 'antd';
import type { FlexProps } from 'antd';

export interface DFlexProps extends FlexProps {}

export const DarwinFlex = (props: DFlexProps) => {
  return <Flex {...props} />;
};
